// extracted by mini-css-extract-plugin
export default {"popover":"customOverlay_popover__W+cL4","overlayDiv":"customOverlay_overlayDiv__eb+R3"};